import OregonCityPageTemplate from "@/pages/oregon-city/CityPageTemplate";
import { newbergConfig } from "./data";

export default function NewbergPage() {
  return <OregonCityPageTemplate config={newbergConfig} />;
}